// Translations for relative time
export const T = {
  en_GB: {
    justNow: "just now",
    minuteAgo: "minute ago",
    minutesAgo: "minutes ago",
    hourAgo: "hour ago",
    hoursAgo: "hours ago",
    dayAgo: "day ago",
    daysAgo: "days ago",
    monthAgo: "month ago",
    monthsAgo: "months ago",
    yearAgo: "year ago",
    yearsAgo: "years ago",
  },
  nb_NO: {
    justNow: "akkurat nå",
    minuteAgo: "minutt siden",
    minutesAgo: "minutter siden",
    hourAgo: "time siden",
    hoursAgo: "timer siden",
    dayAgo: "dag siden",
    daysAgo: "dager siden",
    monthAgo: "måned siden",
    monthsAgo: "måneder siden",
    yearAgo: "år siden",
    yearsAgo: "år siden",
  },
} as const;
